import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=3a5b75ea&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=3a5b75ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5b75ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a5b75ea')) {
      api.createRecord('3a5b75ea', component.options)
    } else {
      api.reload('3a5b75ea', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=3a5b75ea&scoped=true&", function () {
      api.rerender('3a5b75ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4SWvEOW8Z3cw0/JS/comp/PopupBox.vue"
export default component.exports